import { useSelector } from 'react-redux';
import { selectors as authSelectors } from 'src/features/auth/authSlice';
import { Status } from 'src/ts/enums';
/**
 * Custom hook to check if the current user has a specific role.
 *
 * @param requiredRoles - An array of roles to check against the user's role.
 * @returns {boolean} - Returns true if the user has one of the required roles, false otherwise.
 */
const useHasRole = (requiredRoles: string[]): boolean => {
  const user = useSelector(authSelectors.user);
  const userStatus = useSelector(authSelectors.status);
  const isAuthorized = Boolean(user?.email) && userStatus === Status.SUCCESS;

  const hasPermission =
    user && isAuthorized && Array.isArray(requiredRoles) && requiredRoles.includes(user.role);

  return !!hasPermission;
};

export default useHasRole;
